package it.neckar.lizergy.model.configuration.components

import kotlinx.serialization.Serializable

/**
 * The type of AC surge protection (Überspannungsschutz AC).
 *
 * Represents a three-way selection:
 * - [Standard]: Standard AC surge protection
 * - [MitAeusseremBlitzschutz]: AC surge protection considering external lightning protection
 * - [Bauseits]: Customer provides their own AC surge protection ("bauseits")
 */
@Serializable
enum class UeberspannungsschutzACType {
  /**
   * Standard AC surge protection ("Überspannungsschutz AC")
   */
  Standard,

  /**
   * AC surge protection with external lightning protection
   * ("Überspannungsschutz AC mit äußerem Blitzschutz")
   */
  MitAeusseremBlitzschutz,

  /**
   * Customer provides their own AC surge protection ("bauseits")
   */
  Bauseits,
  ;

  /**
   * Returns the quantity for the PDF component table.
   * Bauseits → 0 (customer provides their own), otherwise → 1.
   */
  val anzahl: Int
    get() = when (this) {
      Bauseits -> 0
      Standard, MitAeusseremBlitzschutz -> 1
    }

  fun format(): String {
    return when (this) {
      Standard -> "Überspannungsschutz AC"
      MitAeusseremBlitzschutz -> "Überspannungsschutz AC mit äußerem Blitzschutz"
      Bauseits -> "Überspannungsschutz AC wird bauseits gestellt."
    }
  }
}
